import { MailWarning } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function SafeModeBanner() {
  const { appSettings } = useAuth();
  if (!appSettings || appSettings.email_safe_mode === false) {
    return appSettings ? (
      <div className="w-full bg-red-50 border-b border-red-200 text-red-800 text-xs sm:text-sm px-4 py-2 text-center font-medium" data-testid="safe-mode-off-banner">
        Email safe mode is OFF — emails go to real recipients.
      </div>
    ) : null;
  }
  return (
    <div className="sticky top-0 z-50 w-full bg-amber-100 border-b border-amber-300 text-amber-900 text-xs sm:text-sm px-4 py-2 flex items-center justify-center gap-2 font-medium"
      data-testid="safe-mode-banner">
      <MailWarning className="h-4 w-4 text-amber-600 shrink-0" />
      <span>Email safe mode ON — all email goes to {appSettings.safe_mode_recipient}</span>
    </div>
  );
}
